import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, setAdminToken } from "@/lib/api";

export default function AdminLogin() {
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return toast.error("Enter the admin password.");
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password: pw });
      setAdminToken(res.data.access_token);
      toast.success("Welcome back, Raj.");
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[80vh] container-x grid place-items-center py-16">
      <form onSubmit={submit} data-testid="admin-login-form" className="card-soft w-full max-w-md p-8">
        <div className="grid h-12 w-12 place-items-center rounded-xl bg-brand-forest text-brand-gold">
          <Lock className="h-5 w-5" />
        </div>
        <h1 className="mt-6 font-outfit font-extrabold text-3xl text-brand-forest">Admin Sign-in</h1>
        <p className="mt-2 text-sm text-brand-sage">
          Restricted access for the Swift Financial team.
        </p>

        <div className="mt-6 space-y-2">
          <Label htmlFor="pw" className="text-brand-forest font-medium text-sm">Password</Label>
          <Input
            id="pw"
            data-testid="admin-password"
            type="password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            placeholder="Enter admin password"
          />
        </div>

        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="btn-primary w-full mt-6 disabled:opacity-60"
        >
          {loading ? <><Loader2 className="h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
        </button>
      </form>
    </div>
  );
}
